import invariant from 'invariant';

import Api from './Api';

const GoKids = {
  // Requisição de acesso
  countRequests: () => Api.get('/admin/drivers/requests/count'),
  listRequests: () => Api.get('/admin/drivers/requests'),
  setRequestState: (id, status) => Api.post(`/admin/drivers/requests/${id}/${status}`),

  // ADMIN de familias
  listFamilies: () => Api.get('/admin/families'),
  getFamily: id => Api.get(`/admin/families/${id}/info`),
  listFamilyRequests: () => Api.get('/admin/families/requests'),
  getFamilyRequest: id => Api.get(`/admin/families/requests/${id}/info`),
  updateFamilyRequest: (id, data) => Api.put(`/admin/families/requests/${id}/info`, data),
  countFamilyRequest: () => Api.get('/admin/families/requests/count'),

  // Admin de motoristas
  listDrivers: () => Api.get('/admin/drivers'),
  getDriver(id) {
    invariant(id, 'ID is required');
    return Api.get(`/admin/drivers/${id}`);
  },
  getDriverFamilies: id => Api.get(`/children/families?driverId=${id}`),
  upsertDriver(data, id) {
    if (id) return Api.put(`/admin/drivers/${id}`, data);
    return Api.post('/admin/drivers', data);
  },

  getDriverPayments: driver => Api.get(`/admin/drivers/${driver}/payments`),
  addPayment: (driver, data) => Api.post(`/admin/drivers/${driver}/payments`, data),
  deletePayment: (driver, paymentId) => Api.delete(`/admin/drivers/${driver}/payments/${paymentId}`)
};

export default GoKids;



// WEBPACK FOOTER //
// ./src/services/GoKids.js